module.exports = __webpack_public_path__ + "assets/54d9668676073e5fd07b14ecbe6e7c9c.png";